<template>
  <div 
    class="xit-fb-template node"
    @dblclick.stop="handleClick(node)" 
    :class="[camelCase(node.name), hasData(node), isSelected(node)]" 
  >
    <div class="title">
      <p class="title-content"><i class="fas fa-comment-dots card-start-icon"></i> {{node.lingualName}} <span v-if="node.data.replyTypeText" class="button_type_text">{{ node.data.replyTypeText }}</span></p>
    </div>

    <div class="card-body-handler card_data_body p-0">
      
      <div ref="displayStatHtml"></div>

      <div class="card-data">
        <div class="text-center mb-1">        
          <div class="list-group" v-if="'postback' === node.data.replyType">
            <input type="text" class="single_button btn btn-light mt-0" placeholder="Quick Reply" :value="node.data.buttonText">
            <span class="list-group-item list-group-item-action flex-column align-items-start">
              <div class="d-flex w-100 justify-content-between">
                <h6 class="mb-1 card-data-title link-preview">
                  <i class="fas fa-circle text-success"></i> {{ node.data.postbackIdText }}
                </h6>              
              </div>           
            </span>
          </div>
          <div class="list-group" v-else-if="'newPostback' === node.data.replyType">
            <input type="text" class="single_button btn btn-light mt-0" placeholder="Quick Reply" :value="node.data.buttonText">
          </div>
          <div v-else>            
            <input type="text" class="single_button btn btn-light mt-0" placeholder="Quick Reply" :value="node.data.replyTypeText ">
          </div>
        </div>

      </div>

      <div class="card-sockets">
        <div class="output text-right float-right" v-for="output in outputs()" :key="output.key" :class="hasConnection(output) ? 'has-connection' : ''">
          <div class="output-title">{{output.name}}</div>
          <Socket v-socket:output="output" type="output" :socket="output.socket"></Socket>
        </div>
        <div class="input text-left" v-for="input in inputs()" :key="input.key" :class="hasConnection(input) ? 'has-connection' : ''">
          <Socket v-socket:input="input" type="input" :socket="input.socket"></Socket>
          <div class="input-title">{{input.name}}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VueRenderPlugin from 'rete-vue-render-plugin'
import { templateComponentMethods, updateNodeConnections } from '../../functions/utils'

export default {
  name: 'QuickReplyTemplate',
  mixins: [VueRenderPlugin.mixin],
  components: {
    Socket: VueRenderPlugin.Socket
  },

  methods: {
    ...templateComponentMethods,
  },

  async mounted() {
    const result = await this.displayStat(this.$props.node)
    $(this.$refs.displayStatHtml).html(result)

    updateNodeConnections(this.$props.node)
  }
}
</script>